<template lang="pug">
.loading-bar
</template>

<script>
export default {
  name: 'loading-bar',
};
</script>

<style lang="scss" scoped>
.loading-bar {
  height: 4px;
  width: 100%;
  position: relative;
  z-index: 100;
  overflow: hidden;
  background-color: #ddd;
  &:before{
    display: block;
    position: absolute;
    content: "";
    left: -200px;
    width: 200px;
    height: 4px;
    background-color: $theme-success;
    animation: loading 2s linear infinite;
  }
}

@keyframes loading {
    from {left: -200px; width: 30%;}
    50% {width: 30%;}
    70% {width: 70%;}
    80% { left: 50%;}
    95% {left: 120%;}
    to {left: 100%;}
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingBar.vue